import { render, staticRenderFns } from "./MemberDetailUserLayout.vue?vue&type=template&id=f5d9ba36&scoped=true"
import script from "./MemberDetailUserLayout.vue?vue&type=script&lang=js"
export * from "./MemberDetailUserLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d9ba36",
  null
  
)

export default component.exports